import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ProjectCard, ProjectDetails } from "./ProjectCard";

// VR Skateboard
import skateboardImg from "../assets/img/skateboard/Kelly.JPG";
import skateboardDiagram from "../assets/img/skateboard/diagram.png";
import skateboardController from "../assets/img/skateboard/fig3-new3.jpg";
import skateboardUseElastic from "../assets/img/skateboard/fig1a (1).png";
import skateboardUseIsometric from "../assets/img/skateboard/fig1b.png";
import skateboardVideo from "../assets/img/skateboard/Clip.mp4";

// VR Bike
import bikeImg from "../assets/img/bike/IMG20250202230956.jpg";
import bikeAssembly from "../assets/img/bike/all.png";
import bikeAxel1 from "../assets/img/bike/Axel1.png";
import bikeMount from "../assets/img/bike/Mount.png";
import bikePrinting from "../assets/img/bike/printing.png";
import bikeInstalled from "../assets/img/bike/installed2.png";
import bikeCadDownload from "../assets/img/bike/VR_Bike_Parts.zip";

// Walk AR
import walkEnvironmentImg from "../assets/img/walk/image_040_0011.png";
import walkingPathsImg from "../assets/img/walk/Paths_Right_Dir_Far.png";
import studySpaceImg from "../assets/img/walk/IMG20241220145537.jpg";
import walkDemoVideo from "../assets/img/walk/movie_023.mp4";
import virtualEnvironmentImg from "../assets/img/walk/image_011_0111.jpg";

// Pixel Stitch
import pixelStitchImg from "../assets/img/projects/pixelStitch.png";
import pixelStitchReport from "../assets/img/projects/Creative_AI_PixelStitch.pdf";

//CollabXR
import collabXRImg from "../assets/img/collabxr/fluid_dynamics.jpg";
import dbzVideo from "../assets/img/collabxr/DBZ_Initial.mp4";
import explosionVideo from "../assets/img/collabxr/Explosion_to_date.mp4";
import lifeFormationVideo from "../assets/img/collabxr/Life-Orbit.mp4";
import metEdVideo from "../assets/img/collabxr/MetEd.mp4";

// Game Development

// Crazy Train
import crazyTrain1 from "../assets/img/games/Crazy Train/Screenshot_2014-10-31-13-31-06.png";
import crazyTrain2 from "../assets/img/games/Crazy Train/Screenshot_2014-10-31-13-31-25.png";
import crazyTrain3 from "../assets/img/games/Crazy Train/screen568x568.jpeg";

// Invasion
import invasion1 from "../assets/img/games/Invasion/invasion1.png";
import invasion2 from "../assets/img/games/Invasion/invasion2.png";
import invasion3 from "../assets/img/games/Invasion/invasion3.png";

// Starcade
import starcade1 from "../assets/img/games/Starcade/7d667e_94fe55d3c80e47708e38f9366996abb1.png";
import starcade2 from "../assets/img/games/Starcade/7d667e_7450bb3867364f78a493a59271c53993.png";
import starcade3 from "../assets/img/games/Starcade/7d667e_f03d40407c5c47a2bc7afe0cf7444dc4.png";
import starcadePoster from "../assets/img/games/Starcade/Starcade_Poster.jpg";

// Other Projects
import walkARImg from "../assets/img/project-img1.png";
import teacherTrainerImg from "../assets/img/envision/tt-vr.png";
import normandyImg from "../assets/img/project-img1.png";
import microscopeImg from "../assets/img/project-img1.png";
import cubeNadoImg from "../assets/img/project-img1.png";

export const Projects = () => {
  const [expandedProject, setExpandedProject] = useState(null);

  const projects = [
    {
      title: "VR Skateboard",
      category: "XR / Embedded Systems",

      description:
        "A custom balance controller for VR locomotion using load cells, embedded sensors, an ESP32, and Unity.",

      image: skateboardImg,

      tags: ["ESP32", "Arduino", "C++", "Unity", "C#", "VR"],

      details: {
        intro:
          "A custom hardware and software platform for center-of-balance VR locomotion.",

        sections: [
          {
            type: "video",
            title: "Video",
            url: skateboardVideo,
          },

          {
            type: "architecture",
            title: "System Architecture",
            columns: [
              {
                title: "Physical Controller",
                subtitle: "Senses board loading",
                nodes: [
                  {
                    title: "4× Load Cells",
                    text: "Force sensing",
                  },
                  {
                    title: "4× CS1237",
                    text: "24-bit ADC",
                  },
                  {
                    title: "4× Springs",
                    text: "(Optional) Elastic configuration",
                    optional: true,
                  },
                ],
              },
              {
                title: "Embedded System",
                subtitle: "Processes and transmits sensor data",
                nodes: [
                  {
                    title: "ESP32",
                    text: "Main controller",
                    primary: true,
                  },
                  {
                    title: "4× VL53L1X",
                    text: "Board shape sensing",
                  },
                  {
                    title: "KX13x",
                    text: "Motion sensing",
                  },
                  {
                    title: "WS2812B",
                    text: "Visual feedback",
                  },
                ],
              },
              {
                title: "VR Application",
                subtitle: "Maps sensor data to locomotion",
                nodes: [
                  {
                    title: "Unity",
                    text: "Sensor processing",
                  },
                  {
                    title: "Balance Estimation",
                    text: "User intent and board state",
                  },
                  {
                    title: "VR Locomotion",
                    text: "In-game movement",
                  },
                ],
              },
            ],
          },

          {
            type: "gallery",
            title: "Controller",
            text: "Elastic and isometric configurations used for balance-based input.",
            images: [
              {
                image: skateboardController,
                alt: "Elastic and isometric VR Skateboard controller configurations",
                featured: true,
              },
            ],
          },

          {
            type: "tags",
            title: "Hardware",
            items: [
              "ESP32",
              "4× Load Cells",
              "4× CS1237 ADCs",
              "4× VL53L1X ToF",
              "KX13x Accelerometer",
            ],
          },

          {
            type: "links",
            title: "Software",
            items: [
              {
                label: "Unity App",
                sublabel: "VR locomotion",
                url: "https://github.com/MikeGNelson/VR-Skateboard",
              },
              {
                label: "Arduino",
                sublabel: "Controller firmware",
                url: "https://github.com/MikeGNelson/VR-Skateboard-Arduino",
              },
              {
                label: "CS1237 Library",
                sublabel: "ADC driver",
                url: "https://github.com/MikeGNelson/CS1237-Arduino",
              },
            ],
          },

          {
            type: "gallery",
            title: "In Use",
            images: [
              {
                image: skateboardUseElastic,
                alt: "Elastic VR Skateboard controller in use",
              },
              {
                image: skateboardUseIsometric,
                alt: "Isometric VR Skateboard controller in use",
              },
            ],
          },
        ],
      },
    },

    {
      title: "Pixel Stitch",
      category: "Generative AI",

      description:
        "A browser-based generative image editor for creating, editing, drawing, and outpainting with diffusion models.",

      image: pixelStitchImg,

      tags: ["Python", "Flask", "HTML5 Canvas", "Diffusion Models", "RunPod"],

      details: {
        intro:
          "A multi-image generative editing canvas combining traditional image tools with diffusion-based generation, editing, and outpainting.",

        sections: [
          {
            type: "text",
            title: "My Contribution",
            text: "Frontend development · Project planning · Model training · Backend deployment",
          },

          {
            type: "videos",
            title: "Videos",
            items: [
              {
                title: "Interface Demo",
                url: "https://www.youtube.com/embed/UGSOJgDe31s",
              },
              {
                title: "Technical Demo",
                url: "https://www.youtube.com/embed/Vxekqy4QAnQ",
              },
            ],
          },

          {
            type: "grid",
            items: [
              {
                title: "Editor",
                items: [
                  "Layered HTML5 Canvas interface",
                  "Text-to-image generation",
                  "Region-based editing",
                  "Drawing and erasing",
                  "Image positioning and scaling",
                  "Outpainting / autofill",
                ],
              },
              {
                title: "Generative AI",
                items: [
                  "Würstchen V1 / V2",
                  "Pix2Pix-Zero",
                  "Custom diffusion outpainting",
                  "Stable Diffusion XL",
                ],
              },
              {
                title: "Backend",
                items: [
                  "Python / Flask API",
                  "GPU inference on RunPod",
                  "Browser-to-model image pipeline",
                ],
              },
            ],
          },

          {
            type: "document",
            title: "Documentation",
            label: "Project Report",
            sublabel: "Technical project report",
            url: pixelStitchReport,
          },
        ],
      },
    },

    {
      title: "VR Bike",
      category: "XR / Exergaming",

      description:
        "A custom instrumented exercise bike for VR, combining magnetic rotary sensing, embedded electronics, 3D-printed hardware, and a Unity application.",

      image: bikeImg,

      tags: [
        "VR",
        "Unity",
        "C#",
        "ESP32",
        "Arduino",
        "Autodesk Inventor",
        "3D Printing",
      ],

      github: "https://github.com/MikeGNelson/VR-Bike",

      details: {
        intro:
          "A VR exercise-bike system that measures pedal rotation with a magnetic encoder and streams motion data wirelessly to a Unity application.",

        sections: [
          {
            type: "architecture",
            title: "System Architecture",
            columns: [
              {
                title: "Physical Controller",
                subtitle: "Measures exercise-bike motion",
                nodes: [
                  {
                    title: "Bike Crank",
                    text: "Pedal rotation",
                  },
                  {
                    title: "Magnetic Pulley",
                    text: "Transfers crank rotation",
                  },
                  {
                    title: "AS5600",
                    text: "Magnetic rotary sensing",
                  },
                ],
              },
              {
                title: "Embedded System",
                subtitle: "Processes and transmits rotation data",
                nodes: [
                  {
                    title: "ESP32",
                    text: "Main controller",
                    primary: true,
                  },
                  {
                    title: "Bluetooth Serial",
                    text: "Wireless data transmission",
                  },
                ],
              },
              {
                title: "VR Application",
                subtitle: "Maps bike motion into the virtual environment",
                nodes: [
                  {
                    title: "Unity",
                    text: "Receives sensor data",
                  },
                  {
                    title: "Pedal Processing",
                    text: "Interprets rotation",
                  },
                  {
                    title: "VR Movement",
                    text: "In-game locomotion",
                  },
                ],
              },
            ],
          },

          {
            type: "columns",
            columns: [
              {
                title: "Installed Hardware",
                image: bikeInstalled,
                alt: "Custom VR Bike sensing hardware installed on the exercise bike",
                text: "The finished sensing assembly mounts directly to the exercise bike and tracks crank rotation using the magnetic encoder.",
              },
              {
                title: "Fabrication",
                image: bikePrinting,
                alt: "VR Bike components being 3D printed",
                text: "Custom mounting and transmission components were designed for the bike and fabricated using FDM 3D printing.",
              },
            ],
          },

          {
            type: "gallery",
            title: "Custom Hardware",
            text: "A custom rotary sensing and transmission assembly designed in Autodesk Inventor and fabricated with 3D printing.",
            images: [
              {
                image: bikeAssembly,
                alt: "VR Bike CAD assembly",
                featured: true,
              },
              {
                image: bikeMount,
                alt: "VR Bike custom mount",
              },
              {
                image: bikeAxel1,
                alt: "VR Bike pulley and axle component",
              },
            ],
          },

          {
            type: "links",
            title: "Software & Source",
            items: [
              {
                label: "Unity App",
                sublabel: "VR application",
                url: "https://github.com/MikeGNelson/VR-Bike",
              },
              {
                label: "Arduino",
                sublabel: "ESP32 sensor interface",
                url: "https://github.com/MikeGNelson/VR-Bike-Arduino",
              },
              {
                label: "CAD",
                sublabel: "Autodesk Inventor source",
                url: bikeCadDownload,
                download: true,
              },
            ],
          },
        ],
      },
    },

    {
      title: "WalkAR / AvoidanceVR",
      category: "XR / Research Platform",

      description:
        "Networked XR applications for configurable walking and obstacle-avoidance studies with eye tracking, experimenter control, and trajectory analysis.",

      image: walkEnvironmentImg,

      tags: [
        "AR / VR",
        "Unity",
        "C#",
        "Quest Pro",
        "Eye Tracking",
        "Networking",
        "Research",
      ],

      details: {
        intro:
          "XR research applications developed for controlled walking studies, combining configurable environments, networked experiment control, eye tracking, and participant movement collection.",

        sections: [
          {
            type: "gallery",
            title: "Walking Studies",
            images: [
              {
                image: walkEnvironmentImg,
                alt: "Augmented reality walking study environment",
              },
              {
                image: studySpaceImg,
                alt: "Walking study environment with configured walking paths",
              },
            ],
          },

          {
            type: "architecture",
            title: "Study System",
            columns: [
              {
                title: "Experimenter",
                subtitle: "Configures the study",
                nodes: [
                  {
                    title: "Desktop Client",
                    text: "Study control",
                  },
                  {
                    title: "Scenario Configuration",
                    text: "Walking conditions",
                  },
                ],
              },
              {
                title: "XR Application",
                subtitle: "Runs the participant experience",
                nodes: [
                  {
                    title: "Quest Pro",
                    text: "AR / VR presentation",
                    primary: true,
                  },
                  {
                    title: "Eye Tracking",
                    text: "Gaze collection",
                  },
                  {
                    title: "Walking Tracking",
                    text: "Participant movement",
                  },
                ],
              },
              {
                title: "Study Data",
                subtitle: "Captures participant behavior",
                nodes: [
                  {
                    title: "Walking Paths",
                    text: "Recorded trajectories",
                  },
                  {
                    title: "Gaze Data",
                    text: "Visual attention",
                  },
                  {
                    title: "Study Conditions",
                    text: "Trial configuration",
                  },
                ],
              },
            ],
          },

          {
            type: "image",
            title: "Walking Trajectories",
            image: walkingPathsImg,
            alt: "Recorded participant walking trajectories",
          },

          {
            type: "gallery",
            title: "Virtual Environments",
            images: [
              {
                image: virtualEnvironmentImg,
                alt: "Recreated virtual study environment",
              },
            ],
          },

          {
            type: "links",
            title: "Source",
            items: [
              {
                label: "WalkAR",
                sublabel: "AR walking-study application",
                url: "https://github.com/MikeGNelson/WalkAR",
              },
              {
                label: "AvoidanceVR",
                sublabel: "VR walking and avoidance studies",
                url: "YOUR_AVOIDANCE_VR_URL",
              },
            ],
          },
        ],
      },
    },

    {
      title: "CollabXR / MetED",
      category: "XR / Scientific Visualization",

      description:
        "Scientific data visualizations developed for CollabXR and other projects, a published collaborative XR platform for immersive learning and data exploration.",

      image: collabXRImg,

      tags: [
        "XR",
        "Unity",
        "C#",
        "Scientific Visualization",
        "Data Visualization",
        "Education",
      ],

      details: {
        intro:
          "Scientific visualization systems developed for CollabXR, transforming research and educational datasets into interactive 3D content for collaborative immersive environments.",

        sections: [
          {
            type: "videos",
            title: "Scientific Visualizations",
            items: [
              {
                title: "Explosion Data",
                url: explosionVideo,
                local: true,
              },
              {
                title: "Orbit Data",
                url: lifeFormationVideo,
                local: true,
              },
              {
                title: "Meteorological Data",
                url: metEdVideo,
                local: true,
              },
            ],
          },

          {
            type: "links",
            title: "Application",
            items: [
              {
                label: "CollabXR",
                sublabel: "Published XR application",
                url: "https://envision.center/collabxr",
              },
            ],
          },
        ],
      },
    },

    {
      title: "Teacher Trainer",
      category: "XR / Training",

      description:
        "A co-located VR teacher-training simulation where a desktop operator controls escalating disruptive behaviors among virtual students.",

      image: teacherTrainerImg,

      tags: [
        "VR",
        "Unity",
        "C#",
        "Normcore",
        "Networking",
        "Training Simulation",
      ],
    },

    {
      title: "Game Development",
      category: "Games / Undergraduate Work",

      description:
        "Selected games developed during the Michigan State University Game Design and Development Specialization.",

      image: starcade1,

      tags: [
        "Game Development",
        "Gameplay Programming",
        "AI",
        "Tools",
        "Team Development",
      ],

      details: {
        intro:
          "Selected team projects from the Michigan State University Game Design and Development Specialization, highlighting gameplay programming, AI, development tools, and shipped game projects.",

        sections: [
          {
            type: "projectShowcase",
            title: "Starcade",
            text: "A space-based roguelike arcade game developed over fifteen weeks by an eight-person team. I served as lead programmer and worked on enemy AI and weapon systems.",

            images: [starcade1, starcade2, starcade3],

            scrollGallery: true,

            tags: [
              "Lead Programmer",
              "Enemy AI",
              "Weapon Systems",
              "8-Person Team",
            ],
          },

          {
            type: "projectShowcase",
            title: "Crazy Train",
            text: "A tile-swapping puzzle game developed over five weeks by a four-person team and released for iOS and Android. I was one of two programmers.",

            images: [crazyTrain1, crazyTrain2, crazyTrain3],

            scrollGallery: true,

            tags: [
              "Gameplay Programming",
              "Mobile",
              "iOS",
              "Android",
              "4-Person Team",
            ],
          },

          {
            type: "projectShowcase",
            title: "Invasion",
            text: "An action game developed by a six-person team. I served as team leader and programmer, implementing enemy AI, looping levels, and a modular building-design tool.",

            images: [invasion1, invasion2, invasion3],

            scrollGallery: true,

            tags: [
              "Team Lead",
              "Enemy AI",
              "Level Systems",
              "Designer Tools",
              "6-Person Team",
            ],
          },
        ],
      },
    },
  ];

  const openProject = (project) => {
    setExpandedProject(project);

    requestAnimationFrame(() => {
      document
        .getElementById("projects")
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  };

  const closeProject = () => {
    setExpandedProject(null);

    requestAnimationFrame(() => {
      document
        .getElementById("projects")
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  };

  return (
    <section className="project" id="projects">
      <Container>
        <div className="project-header">
          <span className="section-label">SELECTED WORK</span>

          <h2>Projects</h2>

          <p>
            Selected work in immersive computing, simulation, human-computer
            interaction, machine learning, and software engineering.
          </p>
        </div>

        {expandedProject ? (
          <ProjectDetails project={expandedProject} onClose={closeProject} />
        ) : (
          <Row className="project-grid">
            {projects.map((project) => (
              <Col
                xs={12}
                md={6}
                lg={4}
                key={project.title}
                className="project-card-column"
              >
                <ProjectCard
                  project={project}
                  onToggleDetails={() => openProject(project)}
                />
              </Col>
            ))}
          </Row>
        )}

        {!expandedProject && (
          <div className="github-projects">
            <p>
              Additional experiments, prototypes, and earlier work are available
              on GitHub.
            </p>

            <a
              href="https://github.com/MikeGNelson"
              target="_blank"
              rel="noreferrer"
            >
              View all projects on GitHub →
            </a>
          </div>
        )}
      </Container>
    </section>
  );
};
